import React, { Component } from 'react';
import { SALES_SPACE_GROUP, getSalesSpaceGroupIndexFromLabel } from '../../../../config';
import Slider from '../../../filters/types/turnover-sek';
import { applySalesSpaceFilter, salesSpaceLabelsFromIndex } from '../../helpers/filter-helpers';

class Size extends Component {
    
    constructor(props) {
        super(props);
        this.slider = null;
        this.state = {
            values: this.props.filters.salesSpaceGroups.length > 0 ? getSalesSpaceGroupIndexFromLabel(this.props.filters.salesSpaceGroups) : [0, 6],
            salesSpaceGroup: SALES_SPACE_GROUP,
            turnoverClass: []

        };
    }

    getSizeGroup(retailArea) {
        const sizeGroup = this.state.salesSpaceGroup.find(space => {
            return retailArea >= space.min && retailArea <= space.max;
        });
        return sizeGroup ? sizeGroup : {};
    }

    componentDidMount() {
        const result = this.props.units.reduce((total, value) => {
            total[this.getSizeGroup(value.retailArea).label] = total[this.getSizeGroup(value.retailArea).label] ? { label: this.getSizeGroup(value.retailArea).label, count: total[this.getSizeGroup(value.retailArea).label].count + 1} : { count: 1, label: this.getSizeGroup(value.retailArea).label};
            return total;
        }, {});

        const facetValues = Object.keys(result).map(key => {
            return {
                label: result[key].label,
                count: result[key].count
            }
        });

        this.setState({
            turnoverClass: [{
                facetValues
            }],
        }, () => {
            this.props.registerFilter(this);
        });
    }

    filter(units) {
        const labels = salesSpaceLabelsFromIndex(this.state.values);
        const filteredUnits = applySalesSpaceFilter(units, labels, this.props.type);
        return {
            filteredUnits, 
            filter: {
                salesSpaceGroups: labels
            }
        };
    }

    handleChange({ values }) {
        this.setState({
            values
        }, () => {
            this.props.previewFilter();
        });
    }
    registerSlider(comp) {
        this.slider = comp;
    }

    reset() {
        this.setState({
            values: [0, 6]
        }, () => {
            this.slider.handleChange(this.state.values);
            this.props.previewFilter();
        });
    }

    getPropertyName() {
        return this.props.propertyName;
    }

    getValues() {
        return salesSpaceLabelsFromIndex(this.state.values);
    }

    render() {

        if (!this.props.units) return null;

        return (
            <div className="map-filters__filter">
                {this.props.heading &&
                    <h2 className="map-filters__filter-heading">{this.props.heading}</h2>
                }
                <Slider caption={this.props.caption ? this.props.caption : <>Säljyta <span className="classification-form__caption-light">(m2)</span></>} 
                         param="area" 
                         registerComponent={(comp) => this.registerSlider(comp)}    
                         turnoverclass={this.state.turnoverClass} 
                         turnoverClasses={this.state.salesSpaceGroup} 
                         disableFreeText={true} 
                         modifiers={this.props.modifiers}
                         values={this.props.filters.salesSpaceGroups.length > 0 ? getSalesSpaceGroupIndexFromLabel(this.props.filters.salesSpaceGroups) : this.state.values}
                         submitForm={(e, param, args) => this.handleChange(args)} />
            </div>
           
        );
    }
};

export default Size;